import { fokaAxios } from 'app/fokaAxios'

const { get } = fokaAxios

export default {
  getEditlogs: params => get(`/api/v2/histories`, { params }),
  getEditlogDetail: id => get(`/api/v2/histories/${id}`),
  downloadCampaign: campaignId =>
    get(`/api/v2/storage/keyword/campaign/${campaignId}/download`),
  downloadAdGroup: adGroupId =>
    get(`/api/v2/storage/keyword/adGroup/${adGroupId}/download`),
}
